<template>
  <v-app id="app">
    <router-view></router-view>
  </v-app>
</template>

<script setup lang="ts">
import { VApp } from "vuetify/lib/components";
</script>

<style scoped lang="scss">
#app {
  overflow-x: hidden;
  min-height: 100vh;
}
</style>
